/* after changing this file run 'npm run webpack:build' */
import '../content/scss/vendor.scss';
import "../../../../node_modules/jquery/dist/jquery.min.js";
import "../../../../node_modules/popper.js/dist/umd/popper.min.js";
import "../../../../node_modules/bootstrap/dist/js/bootstrap.min.js";